import { jsx as _jsx } from "react/jsx-runtime";
import isNil from 'lodash/isNil';
import ReduxGrid from '../Grid/ReduxGrid';
import { useClearable } from '../../hooks/useClearable';
import { ValidationLabel } from './ValidationLabel';
const getRegvarValue = (row, column)=>{
    const val = row.getRegvar(column.field).value;
    return isNil(val) ? column.fallbackValue : val;
};
const getKey = (row)=>row.getId();
const defaultFilter = (row)=>!row._destroy;
export const SubTableGrid = (props)=>{
    const { id, subTable, filterFn = defaultFilter, sortFn, columns, ...rest } = props;
    let rows = subTable.items.filter(filterFn);
    useClearable((row)=>row.clearSubTable(props.subTable.$rcc.tableName));
    if (sortFn) {
        rows = rows.sort(sortFn);
    }
    const cols = [
        {
            header: '',
            id: 'ValidationStatus',
            renderCell ({ row }) {
                return /*#__PURE__*/ _jsx(ValidationLabel, {
                    row: row
                });
            },
            sortable: false,
            tdProps: {
                style: {
                    width: '.1%',
                    whiteSpace: 'nowrap',
                    paddingLeft: 0,
                    paddingRight: 0,
                    lineHeight: 0,
                    verticalAlign: 'middle'
                }
            },
            thProps: {
                style: {
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        },
        ...columns
    ];
    return /*#__PURE__*/ _jsx(ReduxGrid, {
        ...rest,
        id: id,
        columns: cols,
        rows: rows,
        getKey: getKey,
        getFieldValue: getRegvarValue
    });
};
